class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.clearInputButton = this.querySelector('.search__button-clear');
    this.predictiveSearchResults = this.querySelector('#predictive-search');
    this.loader = this.querySelector('.predictive-search__loader');
    // this.noResults = this.querySelector('#predictive-search__no-results');
    // this.searchForButton = document.getElementById("button__search-for");

    this.suggestions = this.querySelector('.search-modal__suggestions');

    this.searchForm = this.querySelector(".search-modal__form");
    this.searchModalContentRight = this.querySelector('.search-modal__content--right');
    this.searchModalContentLeft = this.querySelector('.search-modal__content--left');

    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    this.clearInputButton.addEventListener("click", (event) => {
      event.preventDefault();
      this.input.value = "";
      this.input.focus();
      this.close();
    });

    // Calculate available height when modal opens
    this.addEventListener('open', this.calculateAvailableHeight.bind(this));

    // Listen for modal opening/closing via details element
    this.detailsElement = this.closest('details');
    if (this.detailsElement) {
      this.detailsElement.addEventListener('toggle', this.onDetailsToggle.bind(this));
    }

    // Recalculate on window resize
    this.resizeHandler = debounce(() => {
      this.calculateAvailableHeight();
    }, 100);
    window.addEventListener('resize', this.resizeHandler);

    // Recalculate on scroll to refresh announcement bar visibility
    this.scrollHandler = debounce(() => {
      this.calculateAvailableHeight();
    }, 50);
    window.addEventListener('scroll', this.scrollHandler);

    // Initial calculation
    this.calculateAvailableHeight();

  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    this.loaderShow();

    fetch(`${routes.predictive_search_url}?q=${searchTerm}&resources[type]=product&resources[limit]=4&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          this.loaderHide();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;

        const searchItems = this.predictiveSearchResults.querySelectorAll(".predictive-search__list-item");

        this.noResults = this.querySelector('#predictive-search__no-results');

        this.searchForButton = this.predictiveSearchResults.querySelector("#button__search-for")?.addEventListener("click", this.search.bind(this));

        if (searchItems.length > 0) {
          this.suggestions?.classList.add('hidden');
        } else {
          if (this.input.value.trim().length === 0) {
            this.suggestions?.classList.remove('hidden');
          }

        }

        this.loaderHide();
        this.open();
      })
      .catch((error) => {
        this.close();
        this.loaderHide();
        throw error;
      });
  }

  onNoResults() {
    this.suggestionsShow();
    this.noResults.classList.remove('hidden');
    this.searchForButton.classList.add('hidden');
  }

  onHasResults() {
    this.suggestionsHide();
    this.noResults.classList.add('hidden');
    this.searchForButton.classList.remove('hidden');
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
    this.calculateAvailableHeight();
    this.addSearchOpenClass();
    this.dispatchEvent(new CustomEvent('open'));
  }

  close() {
    this.suggestions?.classList.remove('hidden');
    this.predictiveSearchResults.style.display = 'none';
    this.removeSearchOpenClass();
  }

  loaderShow() {
    this.loader.classList.remove('hidden');
  }

  loaderHide() {
    this.loader.classList.add('hidden');
  }

  suggestionsShow() {
    this.suggestions?.classList.remove('hidden');
  }

  suggestionsHide() {
    this.suggestions?.classList.add('hidden');
  }

  clear() {
    // this.input.value = "";
  }

  calculateAvailableHeight() {
    if (!this.searchModalContentRight) return;

    // Get left content height
    const leftContentHeight = this.searchModalContentLeft ? this.searchModalContentLeft.offsetHeight : 0;

    // Calculate actual header height
    let headerHeight = 0;
    const headerWrapper = document.querySelector('.header-wrapper');
    const header = document.querySelector('.header');

    if (headerWrapper) {
      const headerWrapperRect = headerWrapper.getBoundingClientRect();
      headerHeight = headerWrapperRect.height;

      // If still 0, try the inner header element
      if (headerHeight === 0 && header) {
        const headerRect = header.getBoundingClientRect();
        headerHeight = headerRect.height;
      }
    } else if (header) {
      // Fallback to header element
      const headerRect = header.getBoundingClientRect();
      headerHeight = headerRect.height;
    }

    // Calculate announcement bar visibility and height
    const announcementBar = document.querySelector('.announcement-bar');
    let announcementVisibleHeight = 0;

    if (announcementBar) {
      const announcementRect = announcementBar.getBoundingClientRect();
      const viewportHeight = window.innerHeight;

      // Check if announcement bar intersects with viewport (any part visible)
      const isVisible = announcementRect.bottom > 0 && announcementRect.top < viewportHeight;

      if (isVisible) {
        // Calculate how much of the announcement bar is actually visible
        announcementVisibleHeight = Math.min(announcementRect.bottom, viewportHeight) - Math.max(announcementRect.top, 0);
      }
    }

    // Set CSS variables for CSS calc() to use
    document.documentElement.style.setProperty('--search-left-height', `${leftContentHeight}px`);
    document.documentElement.style.setProperty('--announcement-visible-height', `${announcementVisibleHeight}px`);
    document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
  }

  onDetailsToggle(event) {
    if (event.target.hasAttribute('open')) {
      // Modal is opening
      this.addSearchOpenClass();
      this.calculateAvailableHeight();
    } else {
      // Modal is closing
      this.removeSearchOpenClass();
    }
  }

  addSearchOpenClass() {
    const stickyHeader = document.getElementById('sticky-header');
    if (stickyHeader) {
      stickyHeader.classList.add('search-open');
    }

    // Add class to header-wrapper for transparent background (like mobile drawer)
    const headerWrapper = document.querySelector('.header-wrapper');
    if (headerWrapper) {
      headerWrapper.classList.add('search-open');
    }

    // Move header up for search using unified positioning
    this.updateHeaderPosition();

    // Also update mobile drawer positioning if it exists
    this.updateMobileDrawerPosition();
  }

  removeSearchOpenClass() {
    const stickyHeader = document.getElementById('sticky-header');
    if (stickyHeader) {
      stickyHeader.classList.remove('search-open');
    }

    // Remove class from header-wrapper (like mobile drawer)
    const headerWrapper = document.querySelector('.header-wrapper');
    if (headerWrapper) {
      headerWrapper.classList.remove('search-open');
    }

    // Reset header position when search closes using unified positioning
    this.updateHeaderPosition();

    // Also update mobile drawer positioning if it exists
    this.updateMobileDrawerPosition();
  }

  // Unified method to handle header positioning for both menu and search
  updateHeaderPosition() {
    const announcementBar = document.querySelector('.announcement-bar');
    const stickyHeader = document.getElementById('sticky-header');

    if (!announcementBar || !stickyHeader) return;

    // Check if either menu drawer or search is open
    const isMenuOpen = stickyHeader.classList.contains('menu-drawer-open');
    const isSearchOpen = stickyHeader.classList.contains('search-open');

    // Only move header up if either menu or search is open
    if (!isMenuOpen && !isSearchOpen) {
      this.resetHeaderPosition();
      return;
    }

    const announcementHeight = announcementBar.offsetHeight;

    // Move if any part of announcement bar is visible in viewport
    const announcementRect = announcementBar.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    // Check if announcement bar intersects with viewport (any part visible)
    const isVisible = announcementRect.bottom > 0 && announcementRect.top < viewportHeight;

    if (isVisible) {
      // Calculate how much of the announcement bar is actually visible
      const visibleHeight = Math.min(announcementRect.bottom, viewportHeight) - Math.max(announcementRect.top, 0);
      const moveAmount = Math.min(visibleHeight, announcementHeight);

      stickyHeader.style.transform = `translateY(-${moveAmount}px)`;
      stickyHeader.style.transition = 'transform 0.3s ease';
    }
  }

  resetHeaderPosition() {
    const stickyHeader = document.getElementById('sticky-header');

    if (stickyHeader) {
      stickyHeader.style.transform = '';
      stickyHeader.style.transition = 'transform 0.3s ease';
    }
  }

  // Update mobile drawer positioning when search state changes
  updateMobileDrawerPosition() {
    const headerDrawer = document.querySelector('header-drawer');
    if (headerDrawer && typeof headerDrawer.updateHeaderPosition === 'function') {
      headerDrawer.updateHeaderPosition();
    }
  }

  search() {
    this.searchForm.submit();
  }

  disconnectedCallback() {
    // Clean up event listeners
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler);
    }
    if (this.scrollHandler) {
      window.removeEventListener('scroll', this.scrollHandler);
    }
    if (this.detailsElement) {
      this.detailsElement.removeEventListener('toggle', this.onDetailsToggle.bind(this));
    }
    // Remove search-open class when component is destroyed
    this.removeSearchOpenClass();
  }
}

customElements.define('predictive-search', PredictiveSearch);